<div class="container">
    <div class="row m-5">
        <div class="col-12 text-center">
            <h1>Donchian M15</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <button *ngFor="let mkt of markets" class="btn btn-primary btn-sm m-1"
                (click)="selMarket(mkt.market)">{{mkt.market}}</button>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-12">
            <app-filtri-donchian (params)="filtra($event)" (params2)="filtra2($event)" (impostaVolume)="impostaVolumeVariabile($event)"></app-filtri-donchian>
        </div>
    </div>
    <div class="row mt-5" *ngIf="loading">
        <div class="col-12 text-center">
            <div class="spinner-border text-success" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <app-trading-system-report #report>
            </app-trading-system-report>
        </div>
    </div>
</div>